import dayjs from "dayjs";
import { getOrgName } from "./url";
import { toast } from "react-toastify";
import { hasRoles } from "./roles";
import { wlsRollName } from "../../customize/defaultValues";
import { showDateTextTZ } from "../../utils/MeetingsTime/datetime.utils.ts";

export function getElapsedTime(meetingStartTime) {
  const now = new Date();
  const elapsed = now - meetingStartTime; // Time in milliseconds
  return Math.floor(elapsed / 1000 / 60); // Convert to minutes
  //return Math.floor(elapsed ); // Convert to minutes
}

export function getMeetingPrefix(nickname) {
  const specialChar = [".", "$", "_", "-", " ", "*", "@"];
  let prefix = nickname;
  specialChar.forEach((element) => {
    prefix = prefix?.replaceAll(element, "");
  });
  return `${getOrgName()}-${prefix}`;
}

export function getOrgParamAPI(param) {
  return `${param}org_name=${getOrgName()}`;
}

export function getUserTZAsParam(param) {
  let user_time_zone = Intl.DateTimeFormat()?.resolvedOptions()?.timeZone;
  if (user_time_zone) {
    return `${param}time_zone=${user_time_zone}`;
  } else {
    return "";
  }
}

export function splitOrgName(value) {
  if (value?.split("-")?.length > 0) {
    return value?.split("-")?.[1];
  } else {
    return value;
  }
}

export function getInvitationContent(meeting, user, validatePL = false) {
  let roomName = meeting?.userRoomName;
  if (user) {
    roomName = user?.user_name;
  }
  let link =
    meeting?.use_personal_link && validatePL
      ? getUrLWithPL(meeting?.personal_link)
      : getUrL(roomName, meeting);

  let text = "";
  if (user) {
    text = `${user?.first_name || ""} ${
      user?.last_name || ""
    } is inviting you to a scheduled meeting.`;
  } else {
    text = `You are being invited to a scheduled meeting.`;
  }
  text += `\n\nTopic: ${meeting?.topic || ""}${
    meeting.description ? `\nDescription: ${meeting.description}` : ""
  }`;
  if (!meeting?.instant_meeting) {
    text += `\nDate: ${showDateTextTZ(
      meeting?.startDateM,
      getTimeZoneDef(meeting),
      "dddd, MMMM D, YYYY h:mm A",
    )}`;
  }
  text += `\n\nLink to join the meeting\n${link}\n\nMeeting ID: ${
    meeting?.meetingId || ""
  }`;

  if (meeting?.use_personal_link && validatePL) {
    text += `\n\n If you experience any issues with the meeting link, please use the following link to join. ${getUrL(
      roomName,
      meeting,
    )}`;
  }

  return text;
}

/**
 * encode the string to an url
 * space (%20), : (%3A), \n (%0A), ,(%2C), /(%2F)
 */
export function getInvitationContentURL(meeting, user) {
  let roomName = meeting?.userRoomName;
  const link = `${window.location.origin}/${roomName}/${meeting?.meetingId}`;
  const fullName = `${user?.first_name || user?.firstName || ""} ${
    user?.last_name || user?.lastName || ""
  }`.trim();

  let text = "";

  if (meeting?.instant_meeting) {
    text = `${
      fullName || "Someone"
    } is inviting you to join a meeting in their personal room.\n\nMeeting ID: ${
      meeting?.meetingId || ""
    }\nLink to join the meeting:\n${link}`;
  } else {
    text = fullName
      ? `${fullName} is inviting you to a scheduled meeting.`
      : `You are being invited to a scheduled meeting.`;

    text += `\n\nTopic: ${meeting?.topic || ""}
Description: ${meeting?.description || ""}
Date: ${showDateTextTZ(
      meeting?.startDateM,
      getTimeZoneDef(meeting),
      "dddd, MMMM D, YYYY h:mm A",
    )} 

Link to join the meeting:
${link}

Meeting ID: ${meeting?.meetingId || ""}`;
  }

  return codeDataforValidURL(text);
}

export const getTimeZoneDef = (meeting) => {
  return (
    meeting?.time_zone || Intl.DateTimeFormat()?.resolvedOptions()?.timeZone
  );
};

/**
 * Extrae y formatea el nombre de ciudad de un string de zona horaria.
 * Ej: "America/Guayaquil" -> "Guayaquil"
 *     "America/Argentina/Buenos_Aires" -> "Buenos Aires"
 */
export function formatTimezoneLabel(timezone) {
  if (!timezone) return "";
  const parts = timezone.split("/");
  const city = parts[parts.length - 1]; // último segmento
  return city.replace(/_/g, " "); // quita guiones bajos
}

export function getInvitationContentURL1(meeting, user) {
  let roomName = meeting?.userRoomName;

  let link = window.location.origin + "/" + roomName + "/" + meeting?.meetingId;
  let text = "";
  if (
    user?.first_name ||
    user?.firstName ||
    user?.last_name ||
    user?.last_name
  ) {
    text = `${user?.first_name || user?.firstName} ${
      user?.last_name || user?.lastName
    } is inviting you to a scheduled meeting.`;
  } else {
    text = `You are being invited to a scheduled meeting.`;
  }
  text += `\n\nTopic: ${meeting?.topic || ""}\nDescription: ${
    meeting.description || ""
  }\nDate: ${showDateTextTZ(
    meeting?.startDateM,
    getTimeZoneDef(meeting),
    "dddd, MMMM D, YYYY h:mm A",
  )}\n\nLink to join the meeting\n${link}\n\nMeeting ID: ${
    meeting?.meetingId || ""
  }\n`;
  return codeDataforValidURL(text);
  //?.replaceAll(" ", "%20")?.replaceAll("\n","%0A")?.replaceAll(":", "%3A")?.replaceAll(",","%2C")?.replaceAll("/","%2F");
}

/**
 * Function to get the meeting url to share.
 * @param {*} meeting Meeting object
 * @returns
 */
export function getUrlToShare(meeting) {
  //split org name
  let roomPrefix = meeting?.userRoomName;
  let org_name = meeting?.host_info?.[0]?.org_name;
  let orgToRedirect = "meet";
  let roomName = "";
  if (roomPrefix?.split("-")?.length > 0) {
    org_name = roomPrefix?.split("-")?.[0];
    roomName = roomPrefix?.split("-")?.[1];
  } else {
    roomName = roomPrefix;
  }
  if (org_name === "wave4") {
    orgToRedirect = "meet";
  }
  let url = `https://${orgToRedirect}/${roomName}/${meeting?.meetingId}`;
  return url;
}

export function getUrL(userNameRoom, meeting) {
  let roomName = meeting?.userRoomName;
  return `${window.location.origin}/${userNameRoom || roomName}/${
    meeting?.meetingId
  }`;
}

export function getUrLWithPL(personalLink) {
  return `${window.location.origin}/my/${personalLink}`;
}

export function getMeetingSettingHostURL(settings) {
  if (settings) {
    let settingsURL =
      "&breakout=" +
      settings?.breakout +
      "&audioDenoiser=on" +
      "&chat=" +
      settings?.chat;
    return settingsURL;
  } else {
    return "";
  }
}

export function getMeetingSettingParticipantURL(
  settings,
  param = "&",
  meeting = null,
) {
  if (settings) {
    let settingsURL =
      param +
      "screenshare=" +
      settings?.screenshare +
      "&audio=" +
      settings?.audio +
      "&video=" +
      settings?.video +
      "&precallCeremony=" +
      settings?.precallCeremony +
      "&audioDenoiser=on" +
      "&chat=on";
    // Add hideParticipantsNames params for webinar mode
    if (
      meeting?.meeting_mode === "VIEWER" &&
      meeting?.settings?.hideParticipantsNames === true
    ) {
      settingsURL += "&subgridLabels=off&people=off";
    }

    return settingsURL;
  } else {
    return "";
  }
}

/**
 * Function to copy the invitation to the meeting, here is necessary the meeting information. It copies the meeting topic, the time, and more information.
 * @param {boolean} copied State that indicates if the text was copied.
 * @param {function} setCopied Function to modify the state of copied.
 * @param {event} e Event given by the botton component
 * @param {user} e (Optional) Object to identify in case that the invitation is from the Co-host
 */
export const invitationToClipboard = ({
  e,
  meeting,
  copied,
  validatePL = true,
  setCopied,
  user,
}) => {
  let userTemp = undefined;
  if (
    user?.user_name ||
    user?.first_name ||
    user?.last_name ||
    user?.username ||
    user?.firstName ||
    user?.lastName
  ) {
    userTemp = {
      first_name: user?.firstName || user?.first_name,
      last_name: user?.lastName || user?.last_name,
      user_name: user?.username || user?.user_name,
    };
  }
  e?.preventDefault();
  navigator.clipboard
    .writeText(getInvitationContent(meeting, userTemp, validatePL))
    .then(() => {
      if (!copied) {
        toast.success("Invitation copied to Clipboard", {
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          progress: undefined,
        });
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 4000);
    })
    .catch((err) => {
      setCopied(false);
      console.error("Something went wrong", err);
    });
};

/**
 * Function to copy the meeting Link into the clipboard.
 * @param {boolean} copied State that indicates if the text was copied.
 * @param {function} setCopied Function to modify the state of copied.
 * @param {event} e Event given by the botton component
 * @param {user} e (Optional) Object to identify in case that the invitation is from the Co-host
 */
export const meetingLinkToClipboard = ({
  e,
  meeting,
  copied,
  validatePL = true,
  setCopied,
  userName,
}) => {
  console.log(
    "meeting?.use_personal_link",
    meeting?.use_personal_link,
    "validatePL",
    validatePL,
  );

  e?.preventDefault();
  navigator.clipboard
    .writeText(
      meeting?.use_personal_link && validatePL
        ? getUrLWithPL(meeting?.personal_link)
        : getUrL(userName || meeting?.userRoomName, meeting),
    )
    .then(() => {
      if (!copied) {
        toast.success(
          userName
            ? "Co-Host Link copied to Clipboard"
            : "Link copied to Clipboard",
          {
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            progress: undefined,
          },
        );
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 4000);
    })
    .catch((err) => {
      setCopied(false);
      console.error("Something went wrong", err);
    });
};

/**
 * Function to verify the type of the meeting. The type depends on the user roles, the meeting configuration products, and other things.
 * The function returns a number that indicates the type of meetin.
 * If it is a user compares if its the owner. If the user is a participant the validation is as a participant, otherwise we need to verify if the user has shopping roles, and then verify if the meeting has an url Store.
 * Notice that we do not validate if we have products and an URL store in the same meeting.
 *
 * (1) is for webinars or just meetings
 * (2) is for meetings with product catalog
 * (3) is for meetings with an URL Store.
 * (4) instant meeting with products and URL available
 *
 * @param {object} meeting The meeting getting as a result of the API request
 * @param {object} user USer get from Auth0 token
 * @returns
 */
export const verifyMeetingType = (meeting, user) => {
  //saber si es host o participante
  if (meeting) {
    if (user && user?.sub === meeting?.id_user) {
      if (
        meeting?.product_ids?.products?.length > 0 ||
        hasRoles(user, wlsRollName)
      ) {
        if (meeting?.url_store && meeting?.url_store?.trim() !== "") {
          return 3; //reunion con url store
        } else if (meeting?.product_ids?.products?.length > 0) {
          return 2; //reunion con productos y catalogo
        } else {
          //if(user?.["https://wherebyfront.vercel.app/roles"]?.includes(wlsRollName)){}
          return 4; //instant meeting
        }
      } else {
        return 1;
      }
    } else {
      if (meeting?.url_store && meeting?.url_store?.trim() !== "") {
        return 3; //reunion con url store
      } else if (meeting?.product_ids?.products?.length > 0) {
        return 2; //reunion con productos y catalogo
      } else {
        return 1; //reunion tipo webinar
      }
    }
  } else {
    return undefined;
  }
};

export const updateMeetingGeneralConfig = (meetingResult, user) => {
  //HEY aqui aun falta consultar
  let type = verifyMeetingType(meetingResult, user);
  sessionStorage?.setItem(
    "wls_meeting_general_config",
    JSON.stringify({
      status: "valid",
      type: type,
      meetingID: meetingResult?.meetingId || meetingResult?.idMeeting,
      instant: meetingResult?.instant_meeting || false,
    }),
  );
  window.dispatchEvent(new Event("wls_update_meetingGeneralConfig"));
};

/**
 * Function to get the meeting type storaged in session storage. If there is not a meeting type returns undefined as a value.
 */
export const updateMeetingConfigFunction = () => {
  let meetingConfig = JSON.parse(
    sessionStorage?.getItem("wls_meeting_general_config"),
  );
  return meetingConfig?.type || undefined;
};

/**
 * Function to get if the meeting is an instant meeting in spite of the meeting Type.
 */
export const isInstantMeeting = () => {
  let meetingConfig = JSON.parse(
    sessionStorage?.getItem("wls_meeting_general_config"),
  );
  return meetingConfig?.instant || false;
};

/**
 * Function to  encode the string to an url
 * @param {*} value stringto be encoded
 * @return string encoded
 */
export const codeDataforValidURL = (value) => {
  const charac = [
    { char: " ", newChar: "%20" },
    { char: ":", newChar: "%3A" },
    { char: "\n", newChar: "%0A" },
    { char: ",", newChar: "%2C" },
    { char: "/", newChar: "%2F" },
    { char: "@", newChar: "%40" },
  ];
  let newString = value;
  charac?.map((item) => {
    newString = newString?.replaceAll(item?.char, item?.newChar);
    return "";
  });
  return newString;
};

/**
 * Function tto validate if a url enter as text is a valid URL, it allows different kind of string patterns as example.com, www.example.com, https://example.com
 * @param {string} url The url sent to validate
 * @returns
 */
export function isValidUrl(url) {
  const patronURL =
    /^(?:(?:(?:https?|ftp):)?\/\/)?(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))\b(?::\d{2,5})?(?:\/\S*)?$/i;
  return patronURL.test(url);
}

/**
 * Sanitizes a URL by lowercasing only the protocol, domain and subdomain.
 * The path, query string and fragment are preserved as-is.
 */
export function sanitizeUrl(url) {
  if (!url) return "";
  const trimmed = url.trim();
  if (!trimmed) return "";

  let withProtocol = trimmed;
  if (!/^https?:\/\//i.test(withProtocol)) {
    withProtocol = `https://${withProtocol}`;
  }

  try {
    const parsed = new URL(withProtocol);
    return `${parsed.origin}${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return trimmed;
  }
}

/**
 * Validates URL structure and returns an error message if invalid.
 * Returns null if the URL is valid.
 */
export function validateUrlStructure(url) {
  if (!url || !url.trim()) return null;

  const trimmed = url.trim();

  // Malformed protocol: "https:/site.com" or "http:site.com"
  if (/^https?:(?!\/)/.test(trimmed) || /^https?:\/(?!\/)/.test(trimmed)) {
    return "The URL protocol is incorrect. It should be https:// or http://";
  }

  let withProtocol = trimmed;
  if (!/^https?:\/\//i.test(withProtocol)) {
    withProtocol = `https://${withProtocol}`;
  }

  try {
    const parsed = new URL(withProtocol);
    if (!parsed.hostname.includes(".")) {
      return "The domain appears to be incomplete. Example: mysite.com";
    }
    return null;
  } catch {
    return "The URL format is not valid. Example: https://mysite.com/page";
  }
}
